import React from "react";
import "./Loaderspinner.css";

function Loaderspinner() {
  return <div className="loader"></div>;
}

export default Loaderspinner;
